import fetch from "../../../../utils/fetch";
import * as types from "./mutation_types";

export const retrieve = ({ commit, state, rootState }, id: any) => {
  commit(types.FEED_SHOW_TOGGLE_LOADING);

  // START:CUSTOM - generated
  let token = rootState.auth.token;
  let options = {};
  // END:CUSTOM - generated

  return fetch("feeds/" + id, options, token)
    .then((response) => response.json())
    .then((data) => {
      commit(types.FEED_SHOW_TOGGLE_LOADING);
      commit(types.FEED_SHOW_SET_RETRIEVED, data);
    })
    .catch((e) => {
      commit(types.FEED_SHOW_TOGGLE_LOADING);
      commit(types.FEED_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.FEED_SHOW_RESET);
};
